import { render, staticRenderFns } from "./custom-text.vue?vue&type=template&id=3387a35e&lang=true&"
import script from "./custom-text.vue?vue&type=script&lang=js&"
export * from "./custom-text.vue?vue&type=script&lang=js&"
import style0 from "./custom-text.vue?vue&type=style&index=0&id=3387a35e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports